import { FC, useMemo } from "react";
import Select from "../../../shared/ui/controls/Select/Select";
import { taskStatusFilterOptions, StatusFilterValue } from "../model/taskStatus";
import { ISelectOption } from "../../../shared/types/ISelectOption";

const ALL_OPTION: ISelectOption = { value: null, label: "Alle Status" };

interface TaskStatusSelectProps {
  value?: StatusFilterValue | null;
  onChange?: (value: StatusFilterValue | null) => void;
  withAllOption?: boolean;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
  error?: string | null;
  size?: "md" | "sm";
}

const TaskStatusSelect: FC<TaskStatusSelectProps> = ({
  value,
  onChange,
  withAllOption = false,
  placeholder = "Status wählen",
  className,
  disabled,
  error,
  size,
}) => {
  const options = useMemo(
    () => (withAllOption ? [ALL_OPTION, ...taskStatusFilterOptions] : taskStatusFilterOptions),
    [withAllOption],
  );

  return (
    <Select
      options={options}
      value={value ?? null}
      onChange={(v) => onChange?.(v as StatusFilterValue | null)}
      placeholder={placeholder}
      className={className}
      disabled={disabled}
      error={error}
      size={size}
    />
  );
};

export default TaskStatusSelect;
